import React from 'react';
import { CartesianGrid, BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Text, Tooltip, Cell } from 'recharts';
import KnotchGraph from '@bit/knotchinc.web-react-components.graphs.knotch-graph';
import { roundedNumber, validateString, validateNumber } from 'helpers/Utils.js';
import { SingleLineCustomTooltip } from 'components/Graphs/GraphHelpers.js';
import { GraphContainer } from '../styled.js';

const validate = ({ data }) =>
  data.every((entity) => validateString(entity.public_id) && validateNumber(entity.num_contents));

const yTickFormatter = (tick) => roundedNumber(tick);

const xTickFormatter = (tick) => tick;

const CustomXTick = (props) => {
  const { x, y, payload, entities } = props;
  const entityData = entities.find((entity) => entity.public_id === payload.value) || {};

  return (
    <React.Fragment>
      <g>
        <defs>
          <pattern
            id={`img${payload.value}`}
            x="0"
            viewBox="0 0 16 16"
            patternUnits="objectBoundingBox"
            y="0"
            height="100%"
            width="100%"
          >
            <image href={entityData.logo_url} x="0" y="0" height="16px" width="16px" />
          </pattern>
        </defs>
        <circle r="16" cx={x} cy={y + 20} fill={`url(#img${payload.value})`} />
      </g>
      <g transform={`translate(${x},${y + 50})`}>
        <Text
          x={0}
          y={0}
          dy={0}
          textAnchor="end"
          fill="#666"
          width={150}
          transform="rotate(-45)"
          verticalAnchor="start"
        >
          {entityData.name}
        </Text>
      </g>
    </React.Fragment>
  );
};

const MultiEntityContentBars = (props) => {
  const { data = [] } = props;
  const bars = data.map((entity) => entity.public_id);

  return (
    <KnotchGraph validate={validate} {...props}>
      <GraphContainer entityLines={bars}>
        <ResponsiveContainer width="100%" height={425}>
          <BarChart data={data}>
            <XAxis
              dataKey="public_id"
              interval={0}
              height={150}
              tickLine={false}
              axisLine={false}
              tickFormatter={xTickFormatter}
              tick={<CustomXTick entities={data} />}
            />
            <YAxis width={50} tickFormatter={yTickFormatter} axisLine={false} tickLine={false} />
            <CartesianGrid vertical={false} stroke={'#F4F4F4'} />
            <Tooltip
              content={SingleLineCustomTooltip}
              entities={data}
              dataKey="public_id"
              cursor={{ fill: '#f5f6f8' }}
            />
            <Bar dataKey="num_contents" fill="#2D8BFF" barSize={2} radius={[50, 50, 50, 50]}>
              {
                data.map((entry, index) => (
                  <Cell key={`cell-${index}`} className={`bar_${entry.public_id}`} />
                ))
              }
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </GraphContainer>
    </KnotchGraph>
  );
};

export default MultiEntityContentBars;
